export default __webpack_public_path__ + "locales/lo-LA/Errors.json?hash=e1f5698ca5984154693d76c284e4fff7";